<script lang="ts">
  import { modal } from '$lib/stores/modalStore'
  import ConfirmModal from './ConfirmModal.svelte'
  import SaveConfirmModal from './SaveConfirmModal.svelte'
  
  let modalState = $state({ isOpen: false, options: null, resolve: null })
  
  $effect(() => {
    const unsubscribe = modal.subscribe(state => {
      modalState = state
    })
    return unsubscribe
  })
  
  function handleSaveConfirm() {
    modal.confirm_result('save')
  }
  
  function handleDiscard() {
    modal.confirm_result('discard')
  }
  
  function handleCancel() {
    modal.confirm_result('cancel')
  }
  
  function handleConfirm() {
    modal.confirm_result(true)
  }
  
  function handleConfirmCancel() {
    modal.confirm_result(false)
  }
</script>

{#if modalState.isOpen && modalState.options}
  {#if modalState.options.type === 'save-confirm'}
    <SaveConfirmModal
      fileName={modalState.options.message.match(/"([^"]*)"/)?.[1] || 'Document'}
      onSave={handleSaveConfirm}
      onDiscard={handleDiscard}
      onCancel={handleCancel}
    />
  {:else}
    <ConfirmModal
      title={modalState.options.title}
      message={modalState.options.message}
      confirmText={modalState.options.confirmText}
      cancelText={modalState.options.cancelText}
      showCancel={modalState.options.showCancel}
      confirmButtonClass={modalState.options.confirmButtonClass}
      onConfirm={handleConfirm}
      onCancel={handleConfirmCancel}
    />
  {/if}
{/if}